import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';

const ArticleDetails = ({ article }) => {
    useEffect( () => {
        Aos.init({duration: 2000})
    }, [])

    const { name, description } = article;
    return (
        <div data-aos='flip-up' className='shadow-md m-5 rounded-md'>
            <div className='p-5'>
                <h2 className='text-2xl font-semibold'>{name}</h2>
                <p className='text-gray-500'>{description}</p>
            </div>
        </div>
    );
};

export default ArticleDetails;